import React, { useCallback } from 'react';
import { BacklogInsightsButton } from '@atlassian/jira-insights-backlog-button/src/ui/index.tsx';
import { useIsCurrentBrowserSupported } from '@atlassian/jira-insights-common/src/controllers/use-is-current-browser-supported/index.tsx';
import { useNudgeStep } from '@atlassian/jira-onboarding-quickstart-core/src/services';
import { BACKLOG_INSIGHTS_NUDGE_ID } from '@atlassian/jira-software-onboarding-nudges--next/src/common/constants';
import { ConditionalNudgeWrapper } from '@atlassian/jira-software-onboarding-nudges--next/src/ui/conditional-nudge-wrapper/index.tsx';
import { BacklogInsightsNudgeAsync } from '@atlassian/jira-software-onboarding-nudges--next/src/ui/scrum-onboarding-tour/backlog-insights/async.tsx';
import { INSIGHTS_PANEL } from '../../../../model/panels/constants';
import { useIsCMPBacklog } from '../../../../state/state-hooks/capabilities';
import type { InsightsButtonProps } from './types';

export const InsightsButton = ({
	onToggle,
	isInsightsPanelOpen,
	boardId,
	edition = null,
}: InsightsButtonProps) => {
	const isSupported = useIsCurrentBrowserSupported();
	const isCMPBacklog = useIsCMPBacklog();
	const [nudgeStep] = useNudgeStep();

	const onToggleHandler = useCallback(() => {
		onToggle(INSIGHTS_PANEL);
	}, [onToggle]);

	if (!isSupported) {
		return null;
	}

	if (!edition) {
		return null;
	}

	return !__SERVER__ ? (
		<ConditionalNudgeWrapper
			Wrapper={BacklogInsightsNudgeAsync}
			conditionsToApplyWrapper={nudgeStep === BACKLOG_INSIGHTS_NUDGE_ID}
		>
			<BacklogInsightsButton
				isSimplifiedProject={!isCMPBacklog}
				isOpen={isInsightsPanelOpen}
				isCompact={false}
				boardId={Number(boardId)}
				edition={edition}
				onToggle={onToggleHandler}
			/>
		</ConditionalNudgeWrapper>
	) : (
		<BacklogInsightsButton
			isSimplifiedProject={!isCMPBacklog}
			isOpen={isInsightsPanelOpen}
			isCompact={false}
			boardId={Number(boardId)}
			edition={edition}
			onToggle={onToggleHandler}
		/>
	);
};
